// Vue
import { createApp, onMounted } from 'vue'

// css
import './css/style.css';
import './css/style-dark.css';
import './css/design-system.css';
import './css/article-stream.css';

// Logger
import logger from './js/logger';
import helper from './js/helper';

// Device detector
import { createDeviceDetector } from "next-vue-device-detector";
export const device = createDeviceDetector()

// Swiper
import { register } from 'swiper/element/bundle'
register();

// Side Panel
import VueSidePanel from 'vue3-side-panel';
import 'vue3-side-panel/dist/vue3-side-panel.css'

// Custom Components
import Counter from './components/Counter.vue'
import CustomButton from './components/CustomButton.vue'
import LoadingIndicator from './components/LoadingIndicator.vue'
import ImageLoader from './components/ImageLoader.vue'
import LoginRegister from './components/LoginRegister.vue'
import ContactForm from './components/ContactForm.vue'
import CategoryNavigation from './components/CategoryNavigation.vue'
import ContentSwiper from './components/ContentSwiper.vue'
import VideoPlayer from './components/VideoPlayer.vue'
import AsyncLoader from './components/AsyncLoader.vue'
import CommentsLoader from './components/CommentsLoader.vue'
import BottomModalSheet from './components/BottomModalSheet.vue'
import CommentsModal from './components/CommentsModal.vue'
import ArticleShare from './components/ArticleShare.vue'
import TranscoderProgress from './components/TranscoderProgress.vue'
import AvatarCropper from './components/AvatarCropper.vue'
import ProfileForm from './components/ProfileForm.vue'
import PasswordForm from './components/PasswordForm.vue'
import DeleteAccountForm from './components/DeleteAccountForm.vue'
import ImpressionTracker from './components/ImpressionTracker.vue'
import SearchModal from './components/SearchModal.vue'
import AdminPanel from './components/AdminPanel.vue'
import RssWidget from './components/RssWidget.vue'
import Clipboard from './components/Clipboard.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import PreferencesForm from './components/PreferencesForm.vue'
import UpVote from './components/UpVote.vue'
import Poll from './components/Poll.vue'
import AsyncRender from './components/AsyncRender.vue'
import CardsGenerator from './components/CardsGenerator.vue'
import ViewportObserver from './components/ScrollToTop.vue'
import ScrollToTop from './components/ScrollToTop.vue'
import VideoTimeline from './components/VideoTimeline.vue'
import Uploader from './components/Uploader.vue'
import Alert from './components/Alert.vue'
import LazyImage from './components/LazyImage.vue'
import ImageSwiper from './components/ImageSwiper.vue'
import GoBack from './components/GoBack.vue'
import HideOnScroll from './components/HideOnScroll.vue'
import VideoPlayerNew from './components/VideoPlayerNew.vue'
import MailingListManager from './components/MailingListManager.vue'
import VideoModal from './components/VideoModal.vue';
import VideoModalListener from './components/VideoModalListener.vue';
import SocialShare from './components/SocialShare.vue';
import ImageEnhancer from "./components/ImageEnhancer.vue";
import ArticleStream from './components/ArticleStream.vue';

// Attach user dataset, passed via frontend on app-level
var userData = {};
var _userData = document.querySelector("#app").dataset.user;

try {
	userData = JSON.parse(_userData);
} catch(e) {
	console.error(e)
}

// Same for device data
var deviceData = {};
var _deviceData = document.querySelector("#app").dataset.device;

try {
	deviceData = JSON.parse(_deviceData);
} catch(e) {
	console.error(e)
}

// App instance
const app = createApp({
  components: {	
		ImpressionTracker,
		TranscoderProgress,
		BottomModalSheet,
		CommentsModal,
		AsyncLoader,
		CommentsLoader,
		CategoryNavigation,
		Counter,
		CustomButton,
		LoadingIndicator,
		ImageLoader,
		LoginRegister,
		ContactForm,
		ContentSwiper,
		ArticleShare,
		AvatarCropper,
		ProfileForm,
		PasswordForm,
		DeleteAccountForm,
		SearchModal,
		AdminPanel,
		RssWidget,
		Clipboard,
		VideoPlayer,
		ThemeSwitcher,
		PreferencesForm,
		UpVote,
		Poll,
		AsyncRender,
		CardsGenerator,
		ViewportObserver,
		ScrollToTop,
		VideoTimeline,
		Uploader,
		Alert,
		LazyImage,
		ImageSwiper,
		GoBack,
		HideOnScroll,
		MailingListManager,
		VideoPlayerNew,
		VideoModal,
		VideoModalListener,
		SocialShare,
		ImageEnhancer,
		ArticleStream
  },
  data() {
		return {
			devMode: null,
			consent: null,
			device: {
				app: deviceData.isApp,
				android: null,
				ios: null,
				mobile: null,
				desktop: null
			},
			user: {
				loggedIn: userData.loggedIn,
				isRedactie: userData.isRedactie,
				darkTheme: userData.darkTheme
			}
		}
  },
	methods: {
		
		setCMP() {
			
			var component = this;
			
			component.$logger('app/setCMP');
			
			if(typeof __tcfapi != "undefined") {
								
				// Watch for user to accept
				__tcfapi('addEventListener', 2, function(tcData, success) {
					
					component.$logger('app/setCMP/status/' + tcData.eventStatus);
								
					if (tcData.eventStatus === 'useractioncomplete') {
			
						component.$logger('app/setCMP/useractioncomplete/string: ' + tcData.tcString);
						
						// Update app data
						component.consent = tcData.tcString;													
					} 
					else if (tcData.eventStatus === 'tcloaded') { } 
					else if (tcData.eventStatus === 'cmpuishown') { }	
				}); 
						
				// Set CMP consent string if available
				__tcfapi('getTCData', 2, function(result, success) {
											
					if (success && result && result.tcString) {
						
						component.$logger('app/setCMP/success/' + result.tcString );					
						component.consent = result.tcString;
						
					} else {
						component.$logger('app/setCMP/consent-string-not-found');
					}
				});
			}
		},	
		
		/*
		 * Toggle login/register modal
		 */
		loginRegister() {		
			var component = this;
			
			if(!this.device.app) {
				UIkit.modal("#login-register-modal").show();
			} else {
				this.$helper.sendAppMessage({
					action: "toggleLogin" 
				});
			}
		}
				
	},
  created() {
		
		var component = this;
		
		component.$logger('app/created');
		
		// Set devMode
		component.devMode = (helper.getURLParameter('dev') == 'true') ? true : false;
		
		// Set some basic device stuff
		component.device.android = device.android;
		component.device.ios = device.ios;
		component.device.mobile = device.mobile;
		component.device.desktop = (!device.mobile) ? true : false;
		
		component.$logger('app/created/device: ' + JSON.stringify(component.device));
		
		// CMP / consent string
		setTimeout(component.setCMP, 1000);
		
		// global variable to check if a user has interacted with the browser
		// uses for videojs
		document.addEventListener('click', function() {
			window.userInteracted = true;
		}, { once: true });
  }
})

// Register logger & helper
app.config.globalProperties.$logger = logger;
app.config.globalProperties.$helper = helper;
app.config.globalProperties.$app = app;

// Use modules
app.use(device)
app.use(VueSidePanel)

// Mount the app
app.mount('#app')
